<template>
	<div id="pageRoot">

		<p class="textBase appearAnimationB" id="text01" style="z-index: 6">
			Imagina de qué otro modo podría volar Venancio y escríbelo.
		</p>

		<p class="textBase appearAnimationA" id="text02" style="z-index: 6">
			Venancio vuela como
		</p>

		<span style="outline: 1px solid #a6a6a6; width: 740px; height: 348px; left: 70px; top: 220px; z-index: 9; position: absolute;"></span>
		<saved-input-long v-bind:page="$parent.page" v-bind:type="$parent.type" number=1 id="inputField01" maxlength="250" style="line-height: 74px;"/>

		<div class="pageElement hover-animation-a" id="textBox01">
			<p class="textBase pageElement" id="text03">
				¡Ahora imagina tú!
			</p>
		</div>


		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		<img src="/pages/img/sordo/svgPage80ZorritoWriting.svg" class="pageElement hover-animation-a" id="zorrito" style="z-index: 7;">
		<img src="/pages/img/sordo/svgPage80Fixed.svg" class="pageElement" style="position: absolute; width: 748px; height: 468px; left: 47px; top: 37px;">
		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
	</div>
</template>
<style scoped>
.tagText
{
position: absolute;
left: 0px;
right: 0px;
top: 5px;
bottom: 0px;

font-size: 36px;
line-height: 49px;
text-align: center;

color: #FEFAFA;
}

#text01
{
position: absolute;
width: 776px;
height: 35px;
left: 88px;
top: 113px;
}
#text02
{
position: absolute;
width: 320px;
height: 46px;
left: 70px;
top: 169px;
font-weight: 300;
font-size: 30px;
}
#text03
{
position: absolute;
width: 341.99px;
height: 62.24px;
left: 32.71px;
top: 28.16px;

font-size: 36px;
line-height: 40px;
color: #FBF8F8;

transform: rotate(0.92deg);
}
#inputField01
{
position: absolute;
width: 700px;
height: 300px;
left: 90px;
top: 220px;
font-size: 33px;
z-index: 10;
}
#zorrito
{
position: absolute;
width: 459.83px;
height: 360.93px;
left: 543.1px;
top: 530px;
}
#textBox01
{
position: absolute;
width: 422.05px;
height: 146.75px;
left: 112px;
top: 590px;
background-image: url(/pages/img/sordo/svgPage80Textbox01.svg);
background-size: cover;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p80/V88.mp4", "p80/V89.mp4", "p80/V90.mp4"]
    }
  }
}
</script>